module.exports = __webpack_public_path__ + "img/information.d1cb2f39.jpg";